import React, { useRef } from "react";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
import { useAppContext } from "../../../context/AppContext";

const TableDebtorReport = ({ table }) => {
  const tableRef = useRef(null);
  const { nomenclatures } = useAppContext();
  const nomenclature = nomenclatures ? JSON.parse(nomenclatures) : [];

  // function formatDate(data) {
  //   const partesData = data.split("-");
  //   const ano = partesData[0];
  //   const mes = partesData[1];
  //   const dia = partesData[2];
  //   return `${dia}/${mes}/${ano
  // }
  return (
    table &&
    Object.keys(table.enterprises).map((enterpriseId, index) => {
      const enterprise = table.enterprises[enterpriseId];
      return (
        <>
          <table
            id="table"
            key={index}
            className="mb-2"
            style={{ width: "100%" }}
            ref={tableRef}
          >
            <tbody>
              <tr
                style={{
                  backgroundColor: "#2d2d2d",
                  color: "#ffffff",
                }}
              >
                <td className="p-2 fw-bolder" colSpan={8}>
                  Empreendimento: {enterprise.name}
                </td>
                <td className="p-2 fw-bolder" colSpan={2}>
                  Total de Contratos Inadimplentes:{" "}
                  {enterprise.sum_enterprise_non_payment}
                </td>
              </tr>
              {Object.keys(enterprise.clients).map((clientId, index) => {
                const client = enterprise.clients[clientId];
                return (
                  <>
                    <tr
                      className="fw-bolder"
                      key={index}
                      style={{
                        backgroundColor: "#b8b8b8",
                        color: "#2D2D2D",
                      }}
                    >
                      <td
                        className="border border-white border-2 p-1"
                        colSpan={6}
                      >
                        Nome: {client.name_cli}
                      </td>
                      <td
                        className="border border-white border-2 p-1"
                        colSpan={3}
                      >
                        Telefone: {client.contact_cli}
                      </td>
                      <td
                        className="border border-white border-2 p-1"
                        colSpan={2}
                      ></td>
                    </tr>
                    <tr
                      className="fw-bolder"
                      style={{
                        backgroundColor: "#b8b8b8",
                        color: "#2D2D2D",
                      }}
                    >
                      <td className="border border-white border-2 p-1">
                        {nomenclature[0]?.value || "Quadra"}
                      </td>
                      <td className="border border-white border-2 p-1">
                        {nomenclature[1]?.value || "Lote"}
                      </td>
                      <td className="border border-white border-2 p-1">
                        Parcela
                      </td>
                      <td className="border border-white border-2 p-1">
                        Descrição
                      </td>
                      <td className="border border-white border-2 p-1">
                        Vencto
                      </td>
                      <td className="border border-white border-2 p-1">
                        Atraso
                      </td>
                      <td className="border border-white border-2 p-1">
                        Valor
                      </td>
                      <td className="border border-white border-2 p-1">
                        Multa
                      </td>
                      <td className="border border-white border-2 p-1">
                        Juros
                      </td>
                      <td className="border border-white border-2 p-1">
                        Total
                      </td>
                    </tr>
                    {Object.keys(client.lands).map((landId, index) => {
                      const land = client.lands[landId];
                      return (
                        <>
                          {land.installments.map((item, index) => {
                            return (
                              <>
                                <tr
                                  key={index}
                                  style={{
                                    border: "1px solid black",
                                  }}
                                >
                                  <td className="border p-1">{item.block}</td>
                                  <td className="border p-1">{item.land}</td>
                                  <td className="border p-1">
                                    {item.sequence_number}
                                  </td>
                                  <td
                                    className="border p-1"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {item.description}
                                  </td>
                                  <td className="border p-1">
                                    {formatDate(item.due_date)}
                                  </td>
                                  <td className="border p-1">{item.delay}</td>
                                  <td className="border p-1">
                                    {formatCurrency(item.value.toFixed(2))}
                                  </td>
                                  <td className="border p-1">
                                    {formatCurrency(item.fine.toFixed(2))}
                                  </td>
                                  <td className="border p-1">
                                    {formatCurrency(item.fee.toFixed(2))}
                                  </td>
                                  <td className="border p-1">
                                    {formatCurrency(
                                      item.value_fine_fee.toFixed(2)
                                    )}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                          <tr className="fw-bolder">
                            <td colSpan={6} align="right">
                              Subtotal do {nomenclature[1]?.value || "Lote"}:
                            </td>
                            <td>
                              {formatCurrency(land.sum_land_value.toFixed(2))}
                            </td>
                            <td>
                              {formatCurrency(land.sum_land_fine.toFixed(2))}
                            </td>
                            <td>
                              {formatCurrency(land.sum_land_fee.toFixed(2))}
                            </td>
                            <td>
                              {formatCurrency(
                                land.sum_land_value_fine_fee.toFixed(2)
                              )}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                    <tr className="fw-bolder">
                      <td colSpan={6} align="right">
                        Subtotal do Cliente:
                      </td>
                      <td>{formatCurrency(client.sum_cli_value.toFixed(2))}</td>
                      <td>{formatCurrency(client.sum_cli_fine.toFixed(2))}</td>
                      <td>{formatCurrency(client.sum_cli_fee.toFixed(2))}</td>
                      <td>
                        {formatCurrency(
                          client.sum_cli_value_fine_fee.toFixed(2)
                        )}
                      </td>
                    </tr>
                  </>
                );
              })}
              <tr className="fw-bolder border-top mt-3 p-2">
                <td colSpan={6} align="right">
                  Total do Empreendimento:
                </td>
                <td>
                  {formatCurrency(enterprise.sum_enterprise_value.toFixed(2))}
                </td>
                <td>
                  {formatCurrency(enterprise.sum_enterprise_fine.toFixed(2))}
                </td>
                <td>
                  {formatCurrency(enterprise.sum_enterprise_fee.toFixed(2))}
                </td>
                <td>
                  {formatCurrency(
                    enterprise.sum_enterprise_value_fine_fee.toFixed(2)
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    })
  );
};

export default TableDebtorReport;
